import SpinResultState from "../../core/src/states/SpinResultState";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import SpinModel from "../../core/src/model/SpinModel";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ViewManager from "../../core/src/utils/ViewManager";
import PointerEvents from "../../core/src/const/PointerEvents";
import SoundVars from "../../core/src/const/SoundVars";
import SoundController from "../../core/src/utils/SoundController";
import UIController from "../../core/src/ui/UIController";
import Button from "../../core/src/views/components/Button";
import { UIModes, UIStates } from "../../core/src/ui/UIStates";
import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import GameModel from "../../core/src/model/GameModel";
import KeyboardManager, { Key } from "../../core/src/utils/KeyboardManager";

export default class VendorSpinResultState extends SpinResultState {
    protected init(): void {
        CommManager.send(
            RequestRegister.get("saveRestoreState"),
            () => { },
            this
        );

        super.init();
    }

    protected setSkipWithSpace() {
        if (GameModel.spaceToSpin) {
            KeyboardManager.onKey("pressed", Key.SPACE, this.skipWithKey, this);
        }
    }

    protected checkAuto() {
        if (AutoplayModel.isAutoSpinActive()) {
            AutoplayModel.checkLossLimitReached()
            AutoplayModel.checkWinLimitReached(SpinModel.winAmount)
            AutoplayModel.checkTotalWinLimitReached()
            AutoplayModel.checkStopOnAnyWin(SpinModel.winAmount)
           // AutoplayModel.checkStopOnBigWin(SpinModel.winAmount) ||
           // AutoplayModel.checkFeatureWin(SpinModel.hasFreespins())
        }
    }
}
